import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--s-6);
  margin-bottom: var(--s-6);
  flex-wrap: wrap;
`;

const TitleBlock = styled.div`
  min-width: 0;
`;

const Eyebrow = styled.div`
  font-size: var(--t-xs);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: var(--s-1);
`;

const Title = styled.h1`
  margin: 0;
  font-size: var(--t-2xl);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ink);
  line-height: 1.15;
`;

const Subtitle = styled.div`
  font-size: var(--t-base);
  color: var(--muted);
  margin: var(--s-1) 0 0;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s-2);
  flex-shrink: 0;
`;

interface ScPageHeaderProps {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

const ScPageHeader: React.FC<ScPageHeaderProps> = ({
  eyebrow,
  title,
  subtitle,
  actions,
}) => (
  <Wrapper>
    <TitleBlock>
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </TitleBlock>
    {actions && <Actions>{actions}</Actions>}
  </Wrapper>
);

export default ScPageHeader;
